import axios from "@/libs/api.request";

var resource = {};

resource.addResource = (r) => {
  return axios.request({
    url: "api/Resource/Add",
    data: r,
    method: "post",
  });
};

resource.updateResource = (r) => {
  return axios.request({
    url: "api/Resource/Update",
    data: r,
    method: "post",
  });
};

resource.resourceList = (query) => {
  return axios.request({
    url: "api/Resource/List",
    params: query,
    method: "get",
  });
};

resource.deleteResource = (r) => {
  return axios.request({
    url: "api/Resource/Delete",
    data: r,
    method: "post",
  });
};

resource.allResourceList = (query) => {
  return axios.request({
    url: "api/Resource/AllList",
    params: query,
    method: "get",
  });
};

resource.setBlackList = ({ id, blackType, blackListType, blackListReason }) => {
  const data = {
    id,
    blackListType,
    blackListReason,
    blackType,
  };
  return axios.request({
    url: "api/Resource/SetBlackList",
    data: data,
    method: "post",
  });
};

resource.listResourceType = (query) => {
  return axios.request({
    url: "api/Resource/listResourceType",
    params: query,
    method: "get",
  });
};

resource.addResourceType = (data) => {
  return axios.request({
    url: "api/Resource/addResourceType",
    data: data,
    method: "post",
  });
};

resource.updateResourceType = (data) => {
  return axios.request({
    url: "api/Resource/updateResourceType",
    data: data,
    method: "post",
  });
};

resource.deleteResourceType = (id) => {
  return axios.request({
    url: "api/Resource/deleteResourceType/" + id,
    method: "get",
  });
};
export default resource;
